module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"serviceDialog.tags.sourceDescription":"The tags visible here are sourced from the last 60 days of usage records for this service. To update the tags of this service, please tag the corresponding resource in the source cloud provider. We recommend utilizing resource policies where appropriate to speed this up."}}')
  delete Component.options._Ctor
}
